/* ==========================================================================
   CLARITY Kollagenberater — Lexikon. Stand 23.08.2026 14:10

   HIER wird der Berater gepflegt, nicht im Widget. Ein neues Stichwort ist
   eine Zeile in dieser Datei — snippets/clarity-advisor.liquid bleibt unberuehrt.

   SO WIRD GEPFLEGT
   Der Berater schickt jede unbeantwortete Frage als GTM-Event
   clarity_advisor_fallback mit dem Wortlaut. Diese Liste woechentlich ansehen
   und die wiederkehrenden Begriffe hier eintragen. Das ist die eigentliche
   Arbeit an der Beta — nicht das Design.

   🔑 REIHENFOLGE ENTSCHEIDET. Der erste Treffer gewinnt:
      "med" ganz oben  — Sicherheit vor Verkauf
      Ziele in der Mitte
      "person" ganz unten — nennt jemand sich UND ein Ziel ("Mann, 43, Knie"),
      gewinnt das Ziel. Steht "person" oben, gewinnt immer die Selbstbeschreibung.

   🔑 TEILWORT-TREFFER. Geprueft wird mit indexOf, also matcht "gelenk" auch
   "Gelenke" und "Gelenkschmerzen". Kurze Allerweltssilben deshalb vermeiden:
   "alt" wuerde in "enthalten" zuschlagen. Lieber "jahre alt" schreiben.
   ========================================================================== */
window.CLARITY_ADV_LEX = [
  { g:"med", w:[
    "arthrose","schmerz","krank","medikament","schwanger","stillen","diabetes",
    "therapie","operation","entzuendung","entzündung","rheuma","tablette",
    "blutdruck","unvertraeglich","unverträglich","diagnose","beschwerden",
    "osteoporose","gicht","bandscheibe","chemo","blutverduenner","blutverdünner"
  ]},
  { g:"haut", w:[
    "haut","falte","haare","haar","naegel","nägel","nagel","beauty","teint",
    "cellulite","bindegewebe","glanz","biotin","hyaluron","straff","elastizität",
    "elastizitaet","poren","aussehen","jugendlich","haarausfall","bruechig","brüchig"
  ]},
  { g:"gelenke", w:[
    "gelenk","knie","ruecken","rücken","sport","training","laufen","knorpel",
    "beweglich","huefte","hüfte","schulter","fortigel","fitness","kraft",
    "regeneration","muskel","sehne","band","joggen","radfahren","crossfit",
    "marathon","belastung","aufbau"
  ]},
  { g:"fokus", w:[
    "fokus","energie","muede","müde","konzentration","kaffee","matcha","morgen",
    "wach","koffein","antrieb","schlapp","leistung","kopf","klar","erschoepft",
    "erschöpft","mittagstief"
  ]},
  { g:"zell", w:[
    "zellschutz","longevity","altern","anti-aging","antiaging","oxidativ","selen",
    "q10","resveratrol","radikale","sonne","uv","zelle","gesund bleiben","vorsorge"
  ]},
  { g:"einnahme", w:[
    "einnahme","einnehmen","einnehm","nehme","nehmen","dosierung","dosis",
    "wie viel","wieviel","wann","löffel","loeffel","mischen","anrühren","anruehren",
    "wasser","gramm","portion","dauer","wie lange","trinke","trinken","anwendung",
    "morgens oder","auf leeren","nuechtern","nüchtern","zubereitung","rezept"
  ]},
  { g:"wirkung", w:[
    "wirkung","wirkt","studie","beleg","wissenschaft","forschung","bringt","hilft",
    "nutzen","sinnvoll","seriös","serioes","beweis","evidenz","funktioniert",
    "erfahrung","bewertung","test","vergleich","besser als","unterschied"
  ]},
  { g:"start", w:[
    "einstieg","anfang","start","basis","empfehlung","erstes","welches","womit",
    "kapsel","pulver","neutral","geschmack","anfaenger","anfänger","beginnen",
    "ausprobieren","testen","unsicher","keine ahnung","weiss nicht","weiß nicht"
  ]},
  { g:"abo", w:[
    "abo","abonnement","kuendigen","kündigen","pausieren","rabatt","guenstig",
    "günstig","preis","kosten","laufzeit","versand","lieferung","sparen",
    "bestellen","zahlung","rechnung","retoure","ruecksendung","rücksendung","club"
  ]},
  { g:"vegan", w:[
    "vegan","vegetarisch","rind","fisch","schwein","halal","koscher","herkunft",
    "laktose","gluten","tierisch","allergen","zucker","süßstoff","suessstoff",
    "inhaltsstoff","zutaten","woher","hergestellt","made in"
  ]},
  /* IMMER ZULETZT — siehe Reihenfolge oben */
  { g:"person", w:[
    "ich bin","jahre","jahr alt","männlich","weiblich","mann","frau","sportler",
    "läufer","laeufer","mutter","vater","senior","geboren","bin schon","bin erst",
    "meine frau","mein mann","für mich","fuer mich","als frau","als mann"
  ]}
];